/***
*
*   EVENT/LIST
*   List all the events in the group
*
**********/

import { useContext, useState, useEffect } from 'react';
import logger from '../../app/logger';
import { ViewContext, Animate, Card, Chart, Table, Breadcrumbs, Paginate, useAPI, useLocation, CustomSearch, useUserEmails } from 'components/lib';

export function Events(props) {

  const location = useLocation();
  const path = location?.pathname.split('/');

  // context
  const context = useContext(ViewContext);
  const eventName = path[2];

  // state 
  const [search] = useState('');
  const [offset, setOffset] = useState(0);
  const [user, setUser] = useState('');
  const [events, setEvents] = useState(null);
  const [chart, setChart] = useState(false);
  const [filter, setFilter] = useState(null);
  const [loading, setLoading] = useState(false);

  const userEmails = useUserEmails();

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    if (userEmails?.data) {
      setUserList(userEmails.data)
    }
  }, [userEmails?.data]);

  // show 25 results at a time
  const limit = 25;

  function deleteEvent(data, callback) {

    const multi = Array.isArray(data);
    const id = multi ? data.map(x => { return x.id }) : data.id;

    context.modal.show({
      title: `Delete ${multi ? 'Events' : 'Event'}`,
      form: {
        id: {
          type: 'hidden',
          value: id
        }
      },
      buttonText: 'Delete',
      text: `Are you sure you want to delete ${multi ? 'these events' : 'this event'}?`,
      url: '/api/event/',
      method: 'DELETE',
      destructive: true,

    }, () => {

      logger.info('event deleted');
      callback();

    });
  }

  return (
    <Animate>

      <Breadcrumbs items={[
        { name: 'groups', url: '/events' },
        { name: eventName, url: `/events/${eventName}` }
      ]} />

      {chart &&
        <Card title={`${eventName} events by day`}>
          <Chart
            type='line'
            data={chart}
          />
        </Card>
      }

      <Paginate
        offset={offset}
        limit={limit}
        total={events?.total}
        loading={loading}
        onChange={x => setOffset(x)}
      />

      <FetchEvents
        user={user}
        filter={filter}
        search={search}
        offset={offset}
        limit={limit}
        name={eventName}
        setUser={x => setUser(x)}
        setLoading={x => setLoading(x)}
        setData={x => setEvents(x)}
        setChart={x => setChart(x)}
      />

      <CustomSearch
        search
        data={events?.results ? events.results : userList?.list}
        loading={loading}
        searchName={'eventList'}
        // setUser={x => setUser(x)}
        setFilter={x => setFilter(x)}
        searchableDropdownData={
          [
            {
              label: 'Email',
              name: 'email',
              placeholder: 'user email',
              options: userList?.list
            },
          ]
        }
      />

      <Card>

        <Table
          selectable
          loading={loading}
          data={filter ? filter : events?.results}
          show={['name', 'user_name', 'user_email', 'time']}
          actions={{

            delete: deleteEvent,
            view: { url: `/events/${eventName}`, col: 'id' }
          }}
          bulkActions={{

            delete: deleteEvent

          }}
        />

      </Card>
    </Animate>
  )
}

function FetchEvents(props) {

  let offset = 0;
  if (props.offset !== 0) {
    offset = props.offset / 25;
  }

  const events = useAPI(`/api/event?search=${props.search}&offset=${offset}&limit=${props.limit}&name=${props.name}${props.user ? `&user=${props.user}` : ''}`);

  useEffect(() => {

    props.setLoading(events.loading);

    if (events.data?.list)
      props.setData(events.data.list);

    if (events.data?.chart)
      props.setChart(events.data.chart);

  }, [events, props]) // Add props to the dependency array

  return false;
}